export { SEOLandingLayout } from './SEOLandingLayout';
